import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { resetCurrentOrder } from "../features/Order/orderSlice";
import { useState } from "react";
import { Link } from "react-router-dom";
import Lottie from 'lottie-react';
import checkMark from "../components/Common/animationJson/check-mark.json";
import failedCheckMark from "../components/Common/animationJson/failed-check.json";
import InvalidRequestPage from "./InvalidRequestPage";
import { ScrollRestoration } from "react-router-dom";
import { resetCartSlice } from "../features/Cart/Cart_Slice";

const moment = require('moment');

/* Flow
    1. User add item to cart
    2. usrr checkout the cart
    3. empty cart
    4. current order is in currentOrderPlaced
    5. after copy the data i have set the null
*/

const formatNumber = (number) => {
  if (number) {
    let x = number;
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
      lastThree = ',' + lastThree;
    let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
}

export const paymentLabels = {
  "onlinepayment": "Paid via Card",
  "ONLINEPAYMENT": "Paid via Card",
  "PAYBYCASH": "Cash on Delivery",
  "cod": "Cash on Delivery"
};

function OrderStatusPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('status');
  const message = searchParams.get('message');
  const decodedMessage = message ? decodeURIComponent(message) : null;

  // const order = searchParams.get('order');
  const currentOrderPlaced = useSelector((state) => state.order.currentOrderPlaced);
  const [confirmationShown, setConfirmationShown] = useState(false);



  useEffect(() => {
    //empty the user Cart from frontend because backend se when order is created i automatically cleared the cart
    dispatch(resetCartSlice())

    if (confirmationShown && currentOrderPlaced !== null) {
      // Reset Redux state
      dispatch(resetCurrentOrder());
      setConfirmationShown(false)
    }
    setConfirmationShown(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <>
      <ScrollRestoration />
      {(currentOrderPlaced !== null && status === "success") ?
        <div className="bg-white">
          <div className="py-10 px-4 md:px-6 2xl:px-20 lg:max-w-7xl mx-auto ">
            <div className="flex justify-center item-center space-y-2 flex-col text-center">
              <div className="flex justify-center items-center">
                <Lottie animationData={checkMark} loop={false} autoplay={true} className="w-20" />
              </div>
              <h1 className="text-xl lg:text-3xl font-semibold text-gray-900">Thank you for your order!</h1>
              <p className="text-base text-gray-600">The details of your order have been send to your email address.</p>
              <h1 className="text-base font-semibold text-indigo-600">Order Number #{currentOrderPlaced?.orderId}</h1>
              <p className="text-base leading-6 text-gray-600">{moment(currentOrderPlaced?.orderPlaceAt).format('Do MMMM YYYY [at] h:mm A')}</p>
            </div>
            <div className="mt-10 flex flex-col xl:flex-row jusitfy-center items-stretch w-full xl:space-x-8 space-y-4 md:space-y-6 xl:space-y-0">
              <div className="flex flex-col justify-start items-start w-full space-y-0 md:space-y-0 xl:space-y-0">
                <div className="flex flex-col justify-start items-start bg-gray-50 px-4 py-4 md:py-6 md:p-6 xl:p-8 w-full shadow-lg border-gray-200 border-x-[1px] border-t-[1px] rounded-md">
                  <p className="text-lg md:text-xl font-semibold leading-6 xl:leading-5 text-gray-800">Order Summary</p>
                  <div className="mt-4 md:mt-6 flex flex-col md:flex-row justify-start items-start md:items-center md:space-x-6 xl:space-x-8 w-full">
                    <ul className={`border-gray-200 border-t-[1px] w-full`}>
                      {currentOrderPlaced && currentOrderPlaced.items.map((item, index) => (
                        <li key={index + item?.href} className={`flex flex-wrap py-6 sm:py-8 border-gray-200 border-b-[1px]`}>
                          <div className='flex basis-full'>
                            <div className='shrink-0'>
                              <img src={item.images[0]} alt={item.imageAlt} className='h-[7.5rem] w-[7.5rem] rounded-md	object-contain sm:h-32 sm:w-32' />
                            </div>
                            <div className='ml-4 flex flex-1 flex-col justify-around sm:ml-6'>
                              <div className="sm:grid relative pr-9 sm:grid-cols-1	sm:gap-6 sm:pr-0 justify-between">
                                <div className='text-realated'>
                                  <div className='flex justify-between'>
                                    <h3 className='text-base leading-7'>
                                      <Link to={`/${item?.href}/${item?.productId}`} className='font-normal text-opacity-100 text-gray-800 hover:text-indigo-600'>{item.name}</Link>
                                    </h3>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-start flex-col">
                                {item.color &&
                                  <p className='mt-1 text-sm	leading-5	font-medium	text-gray-600'>Color : <span className="text-gray-900 capitalize">{item.color}</span></p>
                                }
                                {item.size &&
                                  <p className='mt-1 text-sm	leading-5	font-medium	text-gray-600'>Size : <span className="text-gray-900">{item.size}</span></p>
                                }
                                <p className='mt-1 text-sm	leading-5	font-medium	text-gray-600'>Price : <span className="text-gray-900">₹{formatNumber(item.price)}</span></p>
                                <div className="flex justify-between">
                                  <p className='mt-1 text-sm	leading-5	font-medium	text-gray-600'>Quantity : <span className="text-gray-900">{item.quantity}</span></p>
                                  <p className='mt-1 text-sm	leading-5	font-medium	text-gray-900'>₹{formatNumber(item.price * item.quantity)}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}

                    </ul>
                  </div>
                </div>
                <div className="flex justify-center md:flex-row flex-col items-stretch w-full space-y-4 md:space-y-0 md:space-x-6 xl:space-x-8">
                  <div className="flex flex-col px-4 pt-2 pb-8 md:px-8 md:pt-0 w-full bg-gray-50 space-y-6 shadow-sm border-gray-200 border-x-[1px] border-b-[1px] rounded-md">
                    {/* <h3 className="text-xl font-semibold leading-5 text-gray-800">Bill Summary</h3> */}
                    <div className="flex justify-center items-center w-full space-y-4 flex-col border-gray-200 border-b pb-4 border-dashed ">
                      <div className="flex justify-between w-full">
                        <p className="text-base leading-4 text-gray-800">Subtotal</p>
                        <p className="text-base leading-4 text-gray-800">₹{formatNumber(currentOrderPlaced.grandTotal)}</p>
                      </div>
                      <div className="flex justify-between items-center w-full">
                        <p className="text-base leading-4 text-gray-800">Shipping & Handling </p>
                        <p className="text-base leading-4 text-gray-800">Free</p>
                      </div>
                      <div className="flex justify-between items-center w-full">
                        <p className="text-base leading-4 text-gray-800">Tax</p>
                        <p className="text-base leading-4 text-gray-800">0.00</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-center w-full">
                      <p className="text-base font-bold leading-4 text-indigo-600">Grand Total</p>
                      <p className="text-base font-bold leading-4 text-indigo-600">₹{formatNumber(currentOrderPlaced.grandTotal)}</p>
                    </div>
                  </div>

                </div>
              </div>
              <div className="bg-gray-50  w-full xl:w-2/5 flex justify-between items-center md:items-start px-4 py-0 md:p-6 xl:p-8  flex-col shadow-sm border-gray-200 border-[1px] rounded-md">
                <div className="flex flex-col md:flex-row xl:flex-col justify-start items-stretch h-full w-full md:space-x-6 lg:space-x-8 xl:space-x-0">

                  <div className="flex justify-between xl:h-full items-stretch w-full flex-col mt-6 md:mt-0 text-left">
                    <div className="flex justify-start md:justify-start xl:flex-col flex-col md:space-x-6 lg:space-x-8 xl:space-x-0 space-y-4 xl:space-y-10 md:space-y-0 md:flex-row items-center md:items-start">
                      <div className="flex justify-start md:justify-start items-start md:items-start flex-col w-full">
                        <p className="text-base font-semibold leading-4 inline-flex items-center mb-4 text-center md:text-left text-gray-800">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 mr-1"> <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /> </svg>
                          Shipping Address</p>
                        <p className="w-full text-left md:text-left text-sm leading-5 text-gray-600 uppercase">{currentOrderPlaced?.shippingAddress.customerName + " " + currentOrderPlaced?.shippingAddress.customerPhoneNo},</p>
                        <p className="w-full text-left md:text-left text-sm leading-5 text-gray-600 uppercase">{currentOrderPlaced?.shippingAddress.customerAddress + "," + currentOrderPlaced?.shippingAddress.customerCity + "," + currentOrderPlaced?.shippingAddress.customerState + "-" + currentOrderPlaced?.shippingAddress.customerPincode}</p>
                      </div>
                      <div className="flex justify-start md:justify-start items-start md:items-start flex-col w-full">
                        <p className="text-base font-semibold leading-4 inline-flex items-center mb-4 text-start md:text-left text-gray-800">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 mr-1"> <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /> </svg>
                          Billing Address</p>
                        <p className="w-full text-left md:text-left text-sm text-gray-600 uppercase">{currentOrderPlaced?.shippingAddress.customerName + " " + currentOrderPlaced?.shippingAddress.customerPhoneNo},</p>
                        <p className="w-full text-left md:text-left text-sm leading-5 text-gray-600 uppercase">{currentOrderPlaced?.shippingAddress.customerAddress + "," + currentOrderPlaced?.shippingAddress.customerCity + "," + currentOrderPlaced?.shippingAddress.customerState + "-" + currentOrderPlaced?.shippingAddress.customerPincode}</p>
                      </div>
                      <div className="flex justify-start md:justify-start items-start md:items-start flex-col  w-full">
                        <p className="text-base font-semibold leading-4 inline-flex items-center mb-4 text-start md:text-left text-gray-800">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 mr-1"> <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" /> </svg>
                          Payment Method</p>
                        <p className="w-full text-left md:text-left text-sm leading-5 text-gray-600 uppercase">{paymentLabels[currentOrderPlaced?.paymentMethod] || currentOrderPlaced.paymentMethod}</p>
                      </div>

                    </div>
                    <div className="flex w-full justify-center items-center md:justify-start md:items-start md:my-4 pb-6 md:pb-0">
                      <Link to={`/account/orders/${currentOrderPlaced?.orderId}`} className="w-full mt-6 md:mt-0 py-3 text-center rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>Track Order</Link>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        (currentOrderPlaced === null && status === "failed") ?
          <div className="py-20 px-4 md:px-6 2xl:px-20 2xl:container 2xl:mx-auto bg-white">
            <div className="flex justify-center item-center space-y-6 flex-col text-center">
              <div className="flex justify-center items-center">
                <Lottie animationData={failedCheckMark} loop={false} autoplay={true} className="w-20" />
              </div>
              <h1 className="text-xl lg:text-3xl font-semibold text-red-600">Sorry, Your Order Could Not Be Placed!</h1>
              <p className="text-base text-gray-600 capitalize w-2/5 mx-auto">{decodedMessage}</p>
              <Link to="/cart" className="w-40 mx-auto py-3 rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>Go To Cart</Link>
            </div>
          </div>

          :

          <InvalidRequestPage />

      }
    </>
  )
}

export default OrderStatusPage;